import { createAction, props } from '@ngrx/store';
import { Organization } from '../../models/organization';

export const selectOrganization = createAction('[Organization] Select Organization', props<{ organizationId: string}>());

export const loadOrganizations = createAction('[Organization/API] Load Organizations ');
export const loadOrganizationsSuccess = createAction('[Organization/API] Load Organizations success', props<{ organizations: Organization[] }>());
export const loadOrganizationsFailure = createAction('[Organization/API] Load Organizations failure', props<{ error: any }>());
